import React from "react"
import { graphql, Link } from "gatsby"
import moment from "moment"
import styled from "styled-components"
import Layout from "../components/layout"
import PageHelmet from "../components/pageHelmet"
import PostMetaItem from "../components/post-meta-item"
import TagItem from "../components/tag-item"
import "katex/dist/katex.min.css"

const PostTitle = styled.h2`
  margin: 0;
  padding: 0 0 1rem 0;
`

const PostSection = styled.section`
  margin: 0;
  padding: 0 0 1rem 0;

  & h1, h2, h3, h4, h5, h6 {
    margin: 2rem 0 1rem 0;
  }

  & a {
    color: #3366cc;
  }

  & a:hover {
    text-decoration: underline;
  }

  & figure {
    margin: 0;
    padding: 0 1rem;
    text-align: center;
    font-size: 0.8rem;
  }

  & figure img {
    margin: 0;
    padding: 0;
  }

  & figure figcaption {
    margin: 0;
    padding: 0.2rem;
  }
`

const PostMetaList = styled.div`
  margin: 0;
  padding: 0;
  color: #333;
  font-size: 0.8rem;
`

const PostTagList = styled.div`
  margin: 0;
  padding: 0;
`

const PostNav = styled.div`
  margin: 0.5rem 0 0 0;
  padding: 0.5rem 0;
  font-size: 0.8rem;
`

const PostNavItemWrapper = styled.div`
  margin: 0 0 0.2rem 0;
  padding: 0.5rem;
  background-color: #f2f2f2;
  font-size: 0.8rem;
  border-radius: 0.3rem;
`

const PostNavItem = props => {
  const direction = props.dir
  const slug = props.post.fields.slug
  const title = props.post.frontmatter.title

  if (slug !== undefined && title !== undefined) {
    return (
      <PostNavItemWrapper>
        {direction}: <Link to={slug}>{title}</Link>
      </PostNavItemWrapper>
    )
  } else {
    return <div />
  }
}

const BlogPostTemplate = props => {
  const post = props.data.currentPost
  const timeToRead = ` ${post.timeToRead} 분`
  const emptyPost = { frontmatter: {}, fields: {} }
  const nextPost = props.data.nextPost || emptyPost
  const previousPost = props.data.previousPost || emptyPost

  const formattedDate = moment(post.frontmatter.date).local().format(` YYYY년 MM월 DD일`)

  return (
    <Layout>
      <PageHelmet title={post.frontmatter.title} />
      <PostTitle>{post.frontmatter.title}</PostTitle>
      <PostMetaList>
        <PostMetaItem icon="🗓" iconLabel="Date" text={formattedDate} />
        {` · `}
        <PostMetaItem icon="⏱" iconLabel="timeToRead" text={timeToRead} />
      </PostMetaList>
      <PostSection dangerouslySetInnerHTML={{ __html: post.html }} />
      <PostTagList>
        {post.frontmatter.tags.map(tag => (
          <TagItem key={tag} name={tag} />
        ))}
      </PostTagList>
      <PostNav>
        <PostNavItem dir={`이전 글`} post={previousPost} />
        <PostNavItem dir={`다음 글`} post={nextPost} />
      </PostNav>
    </Layout>
  )
}

export default BlogPostTemplate

export const query = graphql`
  query($slug: String!, $nextSlug: String!, $previousSlug: String!) {
    currentPost: markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        title
        date
        tags
      }
      timeToRead
    }
    nextPost: markdownRemark(fields: { slug: { eq: $nextSlug } }) {
      frontmatter {
        title
      }
      fields {
        slug
      }
    }
    previousPost: markdownRemark(fields: { slug: { eq: $previousSlug } }) {
      frontmatter {
        title
      }
      fields {
        slug
      }
    }
  }
`
